import { lazy } from "react"

export const FinanceDataPage = lazy(() => import("./FinanceDataPage"))